export class ShipmentPlannerProfileReportLoad {
  public static readonly type = '[ShipmentProfileReport] Load';
}

export class ShipmentPlannerProfileReportInitialState {
  public static readonly type = '[ShipmentProfileReport] Set Initial State';
}
